import { StandardSvgProps } from "src/components/svg/StandardSvgProps";
import { SDefaultSvg } from 'src/components/svg/SvgStyles';
import styled from "src/lib/styles/css";
//#region [Props]
type FilmQuizBrokenHeartSvgProps = {
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function FilmQuizBrokenHeartSvg({ className }: FilmQuizBrokenHeartSvgProps) {
	return (
		<SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" width="35.961" height="29.921" viewBox="0 0 35.961 29.921">
			<HeartPath d="M773.315,318.407a5.211,5.211,0,0,0,7.205,0l10.695-10.56a9.275,9.275,0,0,0,0-13.186,9.445,9.445,0,0,0-13.283,0l-.951.93-.941-.93a9.445,9.445,0,0,0-13.283,0,9.272,9.272,0,0,0,0,13.184Z" transform="translate(-759.005 -290.932)" />
		</SDefaultSvg>
	);
}
//#endregion

//#region [Styles]
const HeartPath = styled.path`
	fill: none !important;
	fill-rule: evenodd;
	stroke:#9075fe;
	stroke-width:2px;
`
//#endregion